export default __webpack_public_path__ + "clientapp/media/robot-01.16300512.png";